import { Grid, Box, Typography } from '@mui/material';

interface KeyInfoFieldProps {
    label: string;
    children: React.ReactNode;
    labelMinWidth?: string;
    labelMarginRight?: string;
    maxWidth?: string;
    avatar?: React.ReactNode;
}

const KeyInfoField: React.FC<KeyInfoFieldProps> = ({ label, children, labelMinWidth = '50px', avatar }) => (
    <Grid size={{ xs: 4, lg: 'auto' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start' }}>
            <Typography variant="subtitle1" sx={{ minWidth: labelMinWidth }}>
                {label}
            </Typography>
            <Box display="flex" alignItems="center" sx={{ flexWrap: 'nowrap', height: '50px' }}>
                {avatar && <Box sx={{ mr: 0.75, flexShrink: 0 }}>{avatar}</Box>}
                {children}
            </Box>
        </Box>
    </Grid>
);

export default KeyInfoField;
